/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
module.exports = {
  // does bucket user
  isFeatureEnabled(key) {
    const settingValue =
      window.Finch != null
        ? window.Finch.getSetting('pull->'.concat(key))
        : undefined;
    return settingValue === 'true' || settingValue === true;
  },

  // does not bucket user
  checkSetting(key) {
    const settingValue =
      window.Finch != null
        ? window.Finch.checkSetting('pull->'.concat(key))
        : undefined;
    return settingValue === 'true' || settingValue === true;
  },

  isInTreatment(experimentName, variantName) {
    return window.Finch != null
      ? window.Finch.inTreatment({
          experimentName,
          variantName,
        })
      : undefined;
  },

  bucketAAExperiment(experimentName) {
    window.Finch &&
      window.Finch.experiment(experimentName, {
        Control() {
          //noop
        },
        Treatment() {
          //noop
        },
      });
  },
};
